module.exports = __webpack_public_path__ + "static/img/solutionDetailPic4.c8bba6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic4.png
// module id = F2Ll
// module chunks = 1